<ng-select
  *ngIf="companies.length !== 0"
  [items]="companies"
  [(ngModel)]="defaultCompany"
  (change)="onCompanySelection($event)"
  [clearable]="false"
  bindValue="id"
  bindLabel="name"
  [ngClass]="designClasses"
>
</ng-select>
